import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { schoolService } from '@modules/staff/schools/services/schoolService';
import useFormHook from '@shared/hooks/useFormHook';
import { notifySuccess } from '@config/tostifyConfig/tostifyConfig';

export default function SchoolTranslations({ onClose, school }) {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { register, handleSubmit, setValue, watch } = useForm();
    const watchedValues = watch();
    
 
    useEffect(() => {
        const fetchTranslations = async () => {
            if (school) {
                try {
                    setLoading(true);
                    setError(null);
                    const translationData = await schoolService.getTranslation(school.id);
                    
                    setValue('name', school.name || '');
                    setValue('populatedPlace', school.address1 || '');
                    setValue('address', school.address2 || '');

                    if (translationData && translationData.length > 0) {
                        const translation = translationData[0]; 
                        setValue('nameTranslated', translation.name || '');
                        setValue('populatedPlaceTranslated', translation.address1 || '');
                        setValue('addressTranslated', translation.address2 || '');
                        setValue('translate', translation.istranslated === 'Y' ? 'bg' : 'en');
                    } else {
                        setValue('nameTranslated', '');
                        setValue('populatedPlaceTranslated', '');
                        setValue('addressTranslated', '');
                        setValue('translate', 'en'); 
                    }
                } catch (err) {
                    console.error('Error fetching translations:', err);
                    setError('Failed to load translations');
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchTranslations();
    }, [school, setValue]);

    const submitForm = async (data) => {
        try {
            const translationData = {
                instId: school.id,
                langCode: "en_GB",
                translatedName: data.nameTranslated,
                translatedShortName: data.nameTranslated,
                translatedAddress1: data.populatedPlaceTranslated,
                translatedAddress2: data.addressTranslated
            };

            await schoolService.saveTranslation(translationData);
            onClose();
            notifySuccess(t('common.translationSuccessfully'));
        } catch (error) {
            console.error('Error saving translation:', error);
            setError('Failed to save translation');
        }
    };

    if (loading) {
        return (
            <div className="modal show" tabIndex="-1">
                <div className="modal-dialog modal-confirm" ref={modalRef}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>Loading translations...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {t('nav.schools.translations')}
                        </h4>
                        <form id="translationsForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-sections">
                                <div className="form-section">
                                    <div className="form-group">
                                        <span className="span-bold">{t('nav.schools.translationsForm.name')}</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('name')}
                                            value={watchedValues.name || ''}
                                            disabled
                                        />
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">{t('nav.schools.translationsForm.populatedPlace')}</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            disabled
                                            {...register('populatedPlace')}
                                            value={watchedValues.populatedPlace || ''}
                                        />

                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('nav.schools.translationsForm.address')}</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            disabled
                                            {...register('address')}
                                            value={watchedValues.address || ''}
                                        />
                                    </div>
                                </div>

                                <div className="form-section">
                                    <div className="form-group">
                                        <span className="span-bold">{t('nav.schools.translationsForm.nameTranslated')}</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('nameTranslated')}
                                            value={watchedValues.nameTranslated || ''}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('nav.schools.translationsForm.populatedPlaceTranslated')}</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('populatedPlaceTranslated')}
                                            value={watchedValues.populatedPlaceTranslated || ''}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">{t('nav.schools.translationsForm.addressTranslated')}</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('addressTranslated')}
                                            value={watchedValues.addressTranslated || ''}
                                        />
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="translationsForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
}